module.exports = {

    resources: {
        "user-claims": {
            name: 'Permissions'
        }
    }
}
